<template>
  <div>
    <Loading v-if="loading"/>
    <div v-else>
      <div class="row d-none d-md-flex">
        <div class="col-lg-6 pr-lg-1">
          <small>Buscador</small>
          <input type="text" v-model="searchTerm" class="form-control form-control-sm" placeholder="Buscar"/>
        </div>
        <div class="col-lg-3 pr-lg-1">
          <small>Ordenar por</small>
          <select v-model="sortKey" class="form-control form-control-sm">
            <option value="fechaCreacion">Fecha</option>
            <option value="nombre">Nombre</option>
            <option value="tipoTexto">Tipo</option>
          </select>
        </div>
        <div class="col-lg-3 pl-lg-1">
          <small class="d-none d-lg-inline">&nbsp;</small>
          <select v-model="reverse" class="form-control form-control-sm">
            <option :value="false">Ascendente</option>
            <option :value="true">Descendente</option>
          </select>
        </div>
      </div>
      <hr class="mb-0"/>
      <div v-for="documento in filtered" :key="documento.id" 
        class="d-block d-md-flex py-2 border-bottom clickable list-item" 
        :class="{ 'bg-primary-light': selected == documento }"
        @click="$emit('documento-seleccionado', documento)"
        @dblclick="$emit('documento-seleccionado', documento)">

         <!-- ICONO -->
        <div class="d-block d-md-flex text-center text-md-left px-3">
          <font-awesome-icon icon="file-pdf" class="fa-4x text-muted text-center text-md-left px-2 d-none d-md-inline" v-if="documento.mimeType && documento.mimeType == 'application/pdf'"/>
          <font-awesome-icon icon="file-image" class="fa-4x text-muted text-center text-md-left px-2 d-none d-md-inline" v-else-if="documento.mimeType && documento.mimeType.indexOf('image/') != -1"/>
          <font-awesome-icon icon="file" class="fa-4x text-muted text-center text-md-left px-2 d-none d-md-inline" v-else/>
        </div>

        <div class="d-block w-100">
          <h5 class="mb-1 text-primary-dark">{{ documento.alias }}</h5>

          <div class="row d-none d-md-flex">
            <div class="col-md-6">
              <strong>Fecha:</strong>&nbsp;
              {{ documento.fechaCreacion|fecha }}
            </div>
            <div class="col-md-6">
              <strong>Tipo:</strong>&nbsp;
              {{ documento.tipoTexto }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Loading from '@/components/widgets/Loading'
export default {
  data() {
    return {
      searchTerm: '',
      sortKey: 'fechaCreacion',
      reverse: true
    }
  },
  props: {
    documentos: {
      default:[]
    },
    loading: {
      default: false
    },
    selected: {
      default: null
    }
  },
  computed: {
    filtered() {
      let filtered = [];
      let searchTerm = this.searchTerm.toLowerCase();
      if (this.searchTerm.length > 0) {
        for (let i = 0; i < this.documentos.length; i++) {
          let documento = this.documentos[i];
          if (
            (documento.nombre && documento.nombre.toLowerCase().indexOf(searchTerm) != -1)
            || (documento.tipoTexto && documento.tipoTexto.toLowerCase().indexOf(searchTerm) != -1)
          ) {
            filtered.push(documento);
          }
        }
      } else {
        filtered = this.documentos
      }

      // Ordenar
      filtered = _.orderBy(filtered, this.sortKey, this.reverse ? 'desc' : 'asc');

      return filtered;
    }
  },
  components: {
    Loading
  }
}
</script>
<style>
.list-item.selected {
  background-color: #eee;
}
</style>
